import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposDocumentoSunatConstant } from 'constants/index'

const TipoDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO DOCUMENTO' htmlFor='input-tipoDocumento' xs={4} xl={5} alignRightAt='xs' />
      <Col xs={8} xl={7}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select {...field} id='input-tipoDocumento' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>TODOS</option>
              {TiposDocumentoSunatConstant.__emisorArray.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
